/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  to: 'to',
  nights: 'nights',
  days: 'days',
  perAdult: 'perAdult',
  priceInfo: 'priceInfo',
  totalFrom: 'totalFrom',
  about: 'about',
  inclusions: 'inclusions',
  itinerary: 'itinerary',
  important_info: 'important_info',
  alternative_dates: 'alternative_dates',
  chosen_departure: 'chosen_departure',
  of: 'of',
  view_all: 'view_all',
  show_more: 'show_more',
  show_less: 'show_less',
  day: 'day',
  continue: 'continue',
  prev: 'prev',
  next: 'next',
  previewExample: 'previewExample',
  selectOptions: 'selectOptions',
  BACK_TO_LIST: 'BACK_TO_LIST',
  yourHotel: 'yourHotel',
  perPerson: 'perPerson',
  datesAndPrices: 'datesAndPrices',
  from: 'from',
  meals: 'meals',
  roomOnly: 'roomOnly',
  with: 'with',
  flightFrom: 'flightFrom'
}; export default Keys;